import styled from 'styled-components'
import { INFOBAR_HEIGHT } from '@/v2/constants'

export const Wrapper = styled.div`
  height: calc(100% - ${INFOBAR_HEIGHT});
  overflow-y: auto;
  padding: 38px 64px 60px 48px;
  background: ${({ theme }) => theme.silver.main};

  @media (max-width: 1024px) {
    padding: 16px;
    height: auto;
    min-height: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
  }
`

export const Summary = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 38px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 12px;
    margin-bottom: 20px;
  }
`

export const WhiteBox = styled.div`
  height: 105px;
  width: 100%;
  border-radius: 3px;
  background: ${({ theme }) => theme.white.main};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 1024px) {
    height: 80px;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 16px;
  }
`

// Holds a tile's figure plus its optional breakdown caption, so the tile still
// reads as two columns on mobile instead of splitting into three.
export const Amount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  @media (max-width: 1024px) {
    align-items: flex-end;
  }
`

// The caption lines sit tight to each other but clear of the figure above, so
// they read as a note on it rather than as more figures.
export const Breakdown = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  margin-top: 6px;

  @media (max-width: 1024px) {
    align-items: flex-end;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 20px;
  gap: 26px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (max-width: 1024px) {
    width: 100%;

    button {
      width: 100%;
    }
  }
`
